const url = "https://api.justbooks.in/v1/api/";
// const url = "http://192.168.0.109:8080/v1/api/";


export default url;


// WEBPACK FOOTER //
// ./src/config/url.js